export const convertToDecimal = (value: string | number): number => {
  if (typeof value === 'number') value = value.toString();
  return parseFloat(value.replace(',', '.'));
};
